import axios from "axios";

import { useCallback, useState } from "react";

import { HUBSPOT_SUBMIT_URL } from "./hubspot-config";

interface HubSpotField {
  name: string;
  value: string;
}

export function useHubSpotFormSubmit(formId: string) {
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(
    async (fields: HubSpotField[]): Promise<boolean> => {
      setSubmitting(true);
      try {
        await axios.post(HUBSPOT_SUBMIT_URL(formId), { fields });
        return true;
      } catch {
        return false;
      } finally {
        setSubmitting(false);
      }
    },
    [formId]
  );

  return { submit, submitting };
}
